'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _formatNumber = require('../formatNumber');

var _formatNumber2 = _interopRequireDefault(_formatNumber);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var Component = (_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Component, _React$Component);

  function Component() {
    (0, _classCallCheck3.default)(this, Component);
    return (0, _possibleConstructorReturn3.default)(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
  }

  (0, _createClass3.default)(Component, [{
    key: 'onChange',
    value: function onChange(event) {
      this.props.setLimit(Number(event.target.value));
    }
  }, {
    key: 'renderSelect',
    value: function renderSelect() {
      return _react2.default.createElement(
        'select',
        {
          className: 'paginated-pagination-select',
          value: this.props.limit,
          onChange: this.onChange },
        _react2.default.createElement(
          'option',
          { value: 10 },
          '10'
        ),
        _react2.default.createElement(
          'option',
          { value: 25 },
          '25'
        ),
        _react2.default.createElement(
          'option',
          { value: 50 },
          '50'
        ),
        _react2.default.createElement(
          'option',
          { value: 100 },
          '100'
        ),
        _react2.default.createElement(
          'option',
          { value: 200 },
          '200'
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        'Show ',
        this.renderSelect(),
        ' of ',
        (0, _formatNumber2.default)(this.props.result.totalCount)
      );
    }
  }]);
  return Component;
}(_react2.default.Component), _class2.propTypes = {
  limit: _propTypes2.default.number,
  setLimit: _propTypes2.default.func,
  result: _propTypes2.default.object
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onChange', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'onChange'), _class.prototype)), _class);
exports.default = Component;